import { Table } from "react-bootstrap";
import { useAuth } from "../services/eqqo.auth.service";

import MoneyFormat from "../components/MoneyFormat";

const PaymentHistory = () => {
	const { user } = useAuth();

	return (
		<div>
			<h2>Payment History</h2>
			<Table className="payments-table">
				<thead>
					<tr>
						<th>Date</th>
						<th>Amount</th>
					</tr>
				</thead>
				<tbody>
					{
						user?.orders?.map((order) => (
							<tr key={order.id}>
								<td>
									<span>{new Date(order.date).toLocaleDateString()}</span>
									{order?.orderDetails?.invoice ? (
										<span>
											{" "}
											-{" ("}
											<a
												href={order.orderDetails.invoice}
												rel="noreferrer"
												target="_blank"
											>
												Download Receipt
											</a>
											{")"}
										</span>
									) : null}
								</td>
								<td><MoneyFormat value={order.total / 100} /></td>
							</tr>
						))
					}
				</tbody>
			</Table>
		</div>
	);
};

export default PaymentHistory;
